import { ByteSizeIndicator } from './ByteSizeIndicator';
import { PreviewControls, PreviewControlsMsg, PreviewFooter } from '../../common';

export const Footer = () => {
  return (
    <PreviewFooter data-test="template-editor-email-preview-footer">
      <PreviewControls>
        <ByteSizeIndicator />
      </PreviewControls>
      <PreviewControlsMsg />
    </PreviewFooter>
  );
};
